import { Component } from '@angular/core';
import {DynamicDialogRef} from "primeng/dynamicdialog";
import {FormControl, FormGroup} from "@angular/forms";

@Component({
  selector: 'app-accept-subscription-popup',
  templateUrl: './accept-subscription-popup.component.html',
  styleUrls: ['./accept-subscription-popup.component.scss']
})
export class AcceptSubscriptionPopupComponent {

  formGroup = new FormGroup({
    masriId: new FormControl('')
  })

  constructor(
    private ref: DynamicDialogRef,
  ) {}

  close(status: boolean = false) {
    this.ref.close({status, masriId: this.formGroup.value.masriId ? parseInt(this.formGroup.value.masriId) : undefined});
  }

  accept() {
    this.close(true);
  }

}
